<div class="h-100 d-flex justify-content-around align-items-center gap-0_8">
  <i class="cp icon-comment fs-4" (click)="onClick('comment')" tooltip="Comment">
    <span class="icon-wrapper" *ngIf="showHasCommentIcon()">
      <i class="fas fa-circle top-right-icon"></i>
    </span>
  </i>
  <i class="cp fab fa-mixcloud fs-3" (click)="onClick('uploadLogsToFirebase')" tooltip="Upload logs from device to firebase"></i>
  <i class="cp fas fa-list" (click)="onClick('deviceLogs')" tooltip="Show device logs"></i>
  <i class="cp far fa-trash-alt" (click)="onClick('delete')" tooltip="Delete number"></i>
</div>
